import React from "react";
import { colorTokens } from "../../../designTokens";
import { CenteredPageLoader } from "./CenteredPageLoader";

export interface DataAreaLoaderOverlayProps {
  message: string;
  id: string;
  visible: boolean;
}

/**
 * Centers loader in the middle of a scrollable data region.
 * Parent must have position: relative and flex: 1 (or explicit height).
 * z-index must exceed sticky table columns (patient/name cells use up to 30).
 */
export const DATA_AREA_LOADER_OVERLAY_Z_INDEX = 50;
export const DataAreaLoaderOverlay: React.FC<DataAreaLoaderOverlayProps> = ({
  message,
  id,
  visible,
}) => {
  if (!visible) return null;

  return (
    <div
      id={id}
      role="status"
      aria-live="polite"
      aria-busy="true"
      style={{
        position: "absolute",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: colorTokens["Background/White"],
        zIndex: DATA_AREA_LOADER_OVERLAY_Z_INDEX,
      }}
    >
      <CenteredPageLoader message={message} id={`${id}-spinner`} />
    </div>
  );
};
